export default "__VITE_ASSET__O1g1HGtX__"